import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';

import { metaReducers } from '@lockton-apps/shared/data-access/auth';

import { reducers } from '.';
import { provideReduxDevTools } from './provideReduxDevTools';
import { CoreFacade } from './core.facade';
import { CoreEffects } from './core.effects';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
      },
    }),
    EffectsModule.forRoot([CoreEffects]),
    StoreRouterConnectingModule.forRoot({ stateKey: 'router' }),
  ],
  providers: [CoreFacade],
})
export class SharedDataAccessCoreModule {
  public static forRoot(
    isProduction: boolean
  ): ModuleWithProviders<SharedDataAccessCoreModule> {
    return {
      ngModule: SharedDataAccessCoreModule,
      providers: [...provideReduxDevTools(isProduction)],
    };
  }
}
